import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useNavigate} from "react-router-dom";

const MainPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/sign-in');
    }, [navigate]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>

            </div>
        </section>
    );
};

export default MainPage;
